import Carousel from '@molecules/Carousel/Carousel';
import styled from 'styled-components';
import { rem } from 'polished';

export const StyledSlotDateCarousel = styled(Carousel)`
  padding-bottom: ${rem(16)};
`;
